import { useState } from 'react';
import { Modal } from 'antd';
import { CloseXIcon } from 'icons';
import Image from 'next/image';

import { useAppDispatch, useAppSelector } from 'store';

import { closeAuthModal, setStep } from 'modules/auth';

import FinalStep from './steps/final-step';
import LoginStep from './steps/first-step';
import OtpStep from './steps/second-step';
import RegisterStep from './steps/third-step';

export interface IProfile {
  full_name: string;
  last_name: string;
  role?: string;
  birthday: string;
  gender: string;
  region_id: string;
}

export interface IUserData {
  phone: string;
  code: string;
  profile: IProfile;
}

const defaultProfile: IProfile = {
  full_name: '',
  last_name: '',
  role: '',
  birthday: '',
  gender: '',
  region_id: ''
};

export function AuthModal() {
  const dispatch = useAppDispatch();
  const isOpen = useAppSelector(state => state.authModal.isOpen);
  const step = useAppSelector(state => state.authModal.step);
  const isRequired = useAppSelector(state => state.authModal.isRequired);
  const [data, setData] = useState<IUserData>({
    phone: '',
    code: '',
    profile: defaultProfile
  });

  const getContentWidth = (): number | string => {
    if (step === 4) return 400;
    if (typeof window !== 'undefined' && window.innerWidth > 700) return 866;
    return '90%';
  };

  return (
    <Modal
      open={isOpen}
      footer={null}
      zIndex={99999}
      onCancel={() => {
        dispatch(closeAuthModal());
        dispatch(setStep(1));
      }}
      width={getContentWidth()}
      centered
      maskClosable={!isRequired}
      keyboard={!isRequired}
      closable={!isRequired && step !== 4}
      closeIcon={
        step === 4 ? null : (
          <div className="flex items-center justify-center rounded-full bg-gray-800 p-1 md:p-2">
            <CloseXIcon />
          </div>
        )
      }
      styles={{
        content: { padding: '0', borderRadius: '12px' }
      }}
    >
      <div className="flex flex-col items-center md:flex-row">
        <div className={`w-full ${step !== 4 ? 'md:w-1/2' : 'md:w-full'} p-6`}>
          {step === 1 && <LoginStep data={data} setData={setData} />}

          {step === 2 && <OtpStep data={data} setData={setData} />}

          {step === 3 && <RegisterStep data={data} setData={setData} />}

          {step === 4 && <FinalStep />}
        </div>

        {step !== 4 && (
          <div className="min-h-122 hidden w-1/2 items-center justify-center md:flex">
            <Image
              src="/images/auth-users-image.webp"
              alt="Users"
              width={500}
              height={300}
              className="w-full rounded-br-xl rounded-tr-xl"
              title="Ro'yxatdan o'tish modal rasmi"
              loading="lazy"
            />
          </div>
        )}
      </div>
    </Modal>
  );
}
